module.exports = __webpack_public_path__ + "img/pagina-default.f065b10c.png";